import * as actionTypes from "../actions/actionTypes";

export const updateNetworkStatus = (isOnline) => {
  return {
    type: actionTypes.UPDATE_NETWORK_STATUS,
    isOnline: isOnline,
  };
};
